<template>
  <div>
    <user-detail-title
      first-bread="发展历程"
      second-bread="发展历程修改"
      first-url="/user/develop"
      title-name="发展历程修改"
      ></user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px" v-if="LookData">
        <el-form-item label="年份">
          <el-input v-model="Clist.year" :placeholder="LookData.year"></el-input>
        </el-form-item>
        <el-form-item label="logo图片">
          <el-upload action="/api/photo/uploadFile" :on-success="GetUrlList">
            <el-button slot="trigger" size="small" type="primary">选取图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" :row="4" v-model="Clist.description" :placeholder="LookData.description"></el-input>
        </el-form-item>
        <el-button @click="handleChange">修改</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "DevelopChange",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:null,
        Clist: {
          'id':this.$route.params.id,
          'year':null,
          'address':null,
          'description':null,
        },//表示Change// 添加的数据
      }
    },
    created() {
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetUrlList(file){
        this.Clist.address=file.data;
      },
      handleChange(){
        if (this.Clist.year && this.Clist.description){
          this.$axios.post('/api/develop/update',this.Clist).then(res=>{
            if(res.data.success == true){
              this.Clist= {
                'id':this.$route.params.id,
                'year':null,
                'address':null,
                'description':null,
              }//表示Add添加的数据,
              this.$message({
                message:'修改成功',
                type:'success'
              })
            }
          })
        } else {
          this.$message.warning('年份和描述都要填写')
        }
      },
      GetLookData(id){
        this.$axios.get('/api/develop/getById',{params:{
            id:id
          }}).then(res=>{
          this.LookData=res.data.data
        })
      }

    },
  }
</script>

<style scoped>

</style>